import { Injectable } from "@angular/core";
import { CreateUserRatingDto } from "../dto/create-user-rating.dto";
import { RestService } from "../../../services/rest.service";

@Injectable({
  providedIn: 'root'
})
export class UserRatingApi {

  public apiEndpoint = 'user-rating/'

  constructor(private restService: RestService) {
  }

  create(dto: CreateUserRatingDto) {
    return this.restService.send({
      method: 'POST',
      url: this.apiEndpoint + 'multiple',
      body: dto
    })
  }
  read(ratedToAccountId: string, page: number = 1) {
    return this.restService.send({
      method: 'GET',
      url: this.apiEndpoint,
      query: {
        ratedToAccountId: ratedToAccountId,
        page: page
      }
    })
  }

}
